<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from 'vue-multiselect';
import ProductService from '@/services/product'

import { VMoney } from 'v-money'

export default {
  page: {
    title: 'Categoria',
  },
  components: { Layout, PageHeader, Multiselect },
  directives: { money: VMoney },
  data() {
    return {
      title: 'Categoria',
      category: {},
      categoryId: '',
      categories: [],
    }
  },
  methods: {
    saveCategory() {
      if (!this.category.description) {
        return this.$toast.info('Informe a descrição da categoria');
      }

      let loader = this.$loading.show();

      if (this.category.main_category) {
        this.category.main_category._id;
      }

      ProductService.saveCategory(this.category).then(() => {
        this.$toast.open('Dados atualizados');
        this.$router.push('/categories');

        loader.hide();
      }).catch(() => {
        loader.hide();
        this.$toast.error('Não foi possível efetuar a operação');
      });
    },
    handleFilesUpload(){      
      const files = this.$refs.file.files;
      const oldImage = this.category.image;

      for( var i = 0; i < files.length; i++ ) {
        let file = files[i];
        
        let formData = new FormData();
        formData.append('file', file);

        let loader = this.$loading.show();

        ProductService.uploadCategoryImage(formData).then(res => {
          this.category.image = res.data.url;

          this.$forceUpdate();
          loader.hide();
        }).catch(() => {
          this.$toast.error('Ocorreu um erro ao enviar a imagem');
          this.category.image = oldImage;

          loader.hide();
        })
      }
    },
    removeImage() {
      this.category.image = '';
    }
  },
  async mounted() {    
    let loader = this.$loading.show();

    try {
      this.categoryId = this.$route.params.id;      

      const categoriesResult = await ProductService.getCategories();
      this.categories = categoriesResult.data.categories;

      if (this.categoryId) {
        this.title = 'Editando Categoria';

        const categoryResult = await ProductService.getCategory(this.categoryId);
        this.category = categoryResult.data;

        this.category.main_category = categoriesResult.data.categories.find(item => {
          return this.category.main_category === item._id;
        })
      } else {
        this.title = 'Nova Categoria';
      }

      loader.hide();
    } catch (err) {
      this.$toast.error('Ocorreu um erro inesperado');
      loader.hide();
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="card">
      <div class="card-body">
        <!-- <h4 class="card-title">Dados do Produto</h4>
        <p class="card-title-desc">Preencha os dados</p> -->
        <form>
          <div class="row">
            <div class="col col-5 col-sm-5">
              <div class="row">
                <div class="col-10">
                  <div class="form-group">
                    <label for="categoryDescription">Descrição</label>
                    <input id="categoryDescription" name="categoryDescription" type="text" class="form-control" v-model="category.description" />
                  </div>
                </div>

                <div class="col-2">
                  <div class="form-group">
                    <label for="categorySequence">Ordem</label>
                    <input id="categorySequence" name="categorySequence" type="text" class="form-control" v-model="category.sequence" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="control-label">Categoria Pai (opcional)</label>
                    <multiselect
                      v-model="category.main_category"
                      :options="categories"
                      placeholder="Selecione uma opção"
                      label="description"
                      track-by="_id"
                      selectLabel="Enter para selecionar"
                      selectedLabel="Selecionado"
                      deselectLabel="Enter para remover"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4 ml-4">
              <div class="form-group">
                <label class="control-label">Imagem (opcional)</label>
                
                <div class="image-upload" @click="$refs.file.click()" v-if="!category.image">
                  <p>Clique para adicionar uma imagem para a categoria</p>
                </div>

                <div class="image" v-if="category.image">
                  <img :src="category.image" @click="$refs.file.click()" />
                  <b-button pill variant="link" class="mt-2" @click="removeImage">Remover</b-button>
                </div>

                 <input type="file" multiple accept="image/*" name="file" ref="file" v-on:change="handleFilesUpload" />
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-6">
              <div class="custom-control custom-checkbox mb-3">
                <input type="checkbox" class="custom-control-input" id="show_in_home" v-model="category.show_in_home" />
                <label class="custom-control-label" for="show_in_home">Exibir na tela inicial</label>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-6">
              <div class="custom-control custom-checkbox mb-3">
                <input type="checkbox" class="custom-control-input" id="show_as_offers" v-model="category.show_as_offers" />
                <label class="custom-control-label" for="show_as_offers">Exibir automaticamente como promoção</label>
              </div>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-sm-6">
              <div class="image-upload">
                <p>Clique para adicionar uma imagem para a categoria</p>
              </div>
            </div>
          </div> -->
        </form>
      </div>
    </div>
    <div class="row mt-4 align-items-center">
      <div class="col-sm-6">
        <router-link
          tag="a"
          to="/categories"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de categorias
        </router-link>
      </div>
      <!-- end col -->
      <div class="col-sm-6">
        <div class="text-sm-right">
          <!-- <router-link tag="a" to="/ecommerce/checkout" class="btn btn-success">
            Salvar e ir para Imagens
          </router-link> -->

          <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="saveCategory">
            <i class="mdi mdi-plus mr-1"></i> Salvar Categoria
          </button>
        </div>
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>

<style lang="scss">
  .images {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .image {
      display: flex;
      flex-direction: row;
      align-items: center;

      .image-group {
        flex-direction: column;
        display: flex;
      }
    }

    img {
      height: 140px;
      margin: 20px 20px 10px 20px;
      min-height: 80px;
    }

    .new-image {
      // border: 2px dashed #a6b0cf !important;
      height: 140px;
      width: 140px;
      border-radius: 6px;
      color: #a6b0cf;
      // font-size: 30px;
      justify-content: center;
      flex-direction: column;
      display: flex;
      align-items: center;
      // padding: 10px;

      p {
        font-size: 10px;
        text-align: center;
        margin: 6px 0px 0px 0px;
      }

      // margin: 20px;
    }

    input[type="file"] {
      display: none;
    }
  }

  .nav-link.disabled {
    color: #e1e1e1;
  }

  .image-upload {
    height: 120px;
    width: 120px;
    border: 2px dashed #ccc;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;

    p {
      font-size: 10px;
      margin: 0px;
      padding: 10px;
    }
  }

  .image {
    height: 120px;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    flex-direction: column;

    img {
      max-width: 80px;
      max-height: 80px;
    }
  }

  input[type="file"] {
    display: none;
  }
</style>